import Card from '../../../components/card/Card';
import P from '../../../components/texts/p/P';
import Modal from '../../../components/modal/modal';

interface ConfirmSignsModalProps {
  isOpen: boolean;
  onClose: Function;
  onAccept: Function;
}

const ConfirmSignsModal: React.FC<ConfirmSignsModalProps> = ({ isOpen, onClose, onAccept }) => {

  const renderContent = () => {
    return (
      <Card display='grid' gap='16px'>
        <P type='1' variant='neutral' withMargin={false}>
          Al continuar, validás que los contratos están correctamente firmados por las personas idóneas y se pueden instrumentar las líneas correspondientes.
        </P>
      </Card>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      title={'Validar firmas de contratos'}
      primaryText='Validar firmas'
      primaryVariant='primary'
      secondaryText='Volver'
      secondaryVariant='secondary'
      onSecondaryAction={onClose}
      onClose={onClose}
      onPrimaryAction={onAccept}
      children={renderContent()}
      width='450px'
    />
  );
};

export default ConfirmSignsModal;